import {createContext, useEffect, useState} from "react";
import axios from "axios";
import {urlConfig} from "../config/urlConfig";

const DBContext = createContext();

const DBProvider = ({children}) => {

    const [currency, setCurrency] = useState([]);
    const [cambioCurrency, setCambioCurrency] = useState(false);



    const token = localStorage.getItem("token");
    let rol = ""
    if (token !== null) {
        const payload = JSON.parse(atob(token.split(".")[1]));
        rol = payload.rol;
    }

    // ------- Currencies -------
    useEffect(() => {
            axios.get(urlConfig.currencyUrl, {
                headers: {
                    "X-FORM-REQUEST": 1,
                }
            })
            .then((res) => {
                setCurrency(res.data.currencies)
            }).catch((error) => {
                console.log(error);
            })

    }, [setCurrency, cambioCurrency, setCambioCurrency]);

// ------- Stuffing -------


    const data = {

        currency, cambioCurrency, setCambioCurrency,

    }

    return (
        <DBContext.Provider value={data}>
            {children}
        </DBContext.Provider>
    );
}
export {DBProvider}
export default DBContext;
